import { SVGProps, Ref, forwardRef } from 'react';

export const LabelFlameFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .667C2.5.667.667 4.333.667 8S2.5 15.333 8 15.333 15.333 11.667 15.333 8 13.5.667 8 .667M7.46 3.59l-.365-.223-.177.389c-.348.76-.837 1.268-1.344 1.796q-.09.092-.179.186c-.564.592-1.124 1.242-1.318 2.275-.508 2.711 1.579 4.618 3.883 4.618 1.858 0 3.212-.99 3.766-2.335.553-1.342.29-2.988-.972-4.25l-.343-.343-.25.415c-.11.174-.254.33-.405.47-.17.156-.39.318-.658.44.03-.23.045-.51.02-.816-.068-.846-.45-1.883-1.658-2.622"
                fill="currentColor"
            />
        </g>
    </svg>
));
LabelFlameFilledSize16Glyph.displayName = 'LabelFlameFilledSize16Glyph';
